import { Caption, Heading } from '@farol-ds/react'
import { AppBar } from '@jusbrasil-web/shared-appbar'
import { ReactNode } from 'react'

export interface AppbarBaseProps {
  title: string | null
  toolbar: ReactNode
  caption: string
  className?: string
}

export function AppbarBase(props: AppbarBaseProps) {
  const { title, className, toolbar, caption } = props

  return (
    <AppBar className={className}>
      <AppBar.Start>
        <AppBar.StartContent>
          <Caption>{caption}</Caption>
          <Heading>{title}</Heading>
        </AppBar.StartContent>
      </AppBar.Start>
      <AppBar.End>{toolbar}</AppBar.End>
    </AppBar>
  )
}
